import { utcToZonedTime, format as _format } from 'date-fns-tz';
import locale from 'date-fns/locale/zh-TW';

const timeZone = 'Asia/Taipei';

/**
 * @param {Date} date
 * @param {string} format - {@link https://date-fns.org/docs/format}
 */
export default function formatToTaiwanTime(date, format) {
  try {
    return _format(utcToZonedTime(date, timeZone), format, { timeZone, locale });
  } catch {
    return date;
  }
}
